import React, { Component } from "react";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { GoogleLogin } from "@react-oauth/google";
import { initDeviceId } from "../device";
import { ARGUS_APM } from "../../apm";
import { loginWithGoogle } from "../gateway/LoginGateway";
import Types from "prop-types";

const NO_RESPONSE = "no response from Google";
const UNREGISTERED_USER = "unregistered_user";

class GoogleButton extends Component {
  state = {};
  constructor(props) {
    super(props);
    this.responseMessage = this.responseMessage.bind(this);
    this.tryToSignin = this.tryToSignin.bind(this);
  }

  responseMessage(response) {
    const googleIdToken = response.credential;
    this.tryToSignin(googleIdToken);
  }

  async tryToSignin(googleIdToken) {
    const deviceId = await initDeviceId();
    return this.loginGoogleRequest(deviceId, googleIdToken)
      .then((data) => {
        this.props.onChange({ proofToken: data.token }); // login IdP
      })
      .catch((error) => {
        ARGUS_APM.captureError(error);
        if (
          error.response?.status === 400 &&
          error.response.data?.error === UNREGISTERED_USER
        ) {
          this.props.onChange({
            googleIdToken,
          }); // signup
        } else {
          this.props.onChange({
            error: error.response?.data?.message || NO_RESPONSE,
          });
        }
      });
  }

  loginGoogleRequest(deviceId, googleIdToken) {
    return loginWithGoogle(
      {
        device_id: deviceId,
        id_token: googleIdToken,
      },
      this.state.clientId
    );
  }

  errorMessage(error) {
    console.log(error);
  }

  render() {
    // eslint-disable-next-line no-alert 
    return (
      <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
        <React.StrictMode>
          <div className="signin-google-button" data-color="black" data-border="true">
            <GoogleLogin
              onSuccess={this.responseMessage}
              onError={this.errorMessage}
            />
          </div>
        </React.StrictMode>
      </GoogleOAuthProvider>
    );
  }
}

GoogleButton.propTypes = {
  onChange: Types.func,
};
export default GoogleButton;
